module.exports = __webpack_public_path__ + "static/media/twitter_logo.32b96be5.svg";